__turbopack_context__.v({
  "bg": "dn2ylW_bg",
  "close": "dn2ylW_close",
  "closeText": "dn2ylW_closeText",
  "container": "dn2ylW_container",
  "content": "dn2ylW_content",
  "iconClose": "dn2ylW_iconClose",
  "popup": "dn2ylW_popup",
});
